import React, { Fragment, useContext, useMemo } from "react";

import { ElementState } from "@creatomate/preview";
import styled from "styled-components";

import { ElementPlacement } from "chq";
import { IconName } from "@culturehq/components/dist/components/Icon";

import { timeToNumber } from "components/stories/video-studio/utils";

import { useTimelineScale } from "components/stories/video-studio/contexts/TimelineScaleContext";
import VideoThumbnails from "../VideoThumbnails";
import GrabberIcon from "../GrabberIcon";
import { VIDEO_ELEMENT_HEIGHT } from "../Element";
import BarContent from "./BarContent";

const Overlay = styled.div`
  background-color: rgb(0, 0, 0, 0.3);
  height: 100%;
  left: 0;
  position: absolute;
  width: 100%;
`;

interface BarProps {
  currentElement: ElementState;
  iconClass: string;
  iconType: IconName;
  isSmallElement: boolean;
  isVideo: boolean;
  placement: ElementPlacement;
  trimming: boolean;
  withVideos: boolean;
}

const Bar: React.FC<BarProps> = ({
  currentElement,
  iconClass,
  iconType,
  isSmallElement,
  isVideo,
  placement,
  trimming,
  withVideos
}) => {
  const { timelineScale } = useTimelineScale();

  const startTime = useMemo(() => {
    const trimTime = currentElement.source.trim_start
      ? timeToNumber(currentElement.source.trim_start) : 0;
    if (trimming) return (placement.time - currentElement.globalTime) + trimTime;

    return trimTime;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentElement.source.trim_start, trimming]);

  return (
    <Fragment>
      {isVideo && withVideos && (
        <VideoThumbnails
          element={currentElement}
          containerWidth={currentElement.duration * timelineScale}
          containerHeight={VIDEO_ELEMENT_HEIGHT}
          startTime={startTime}
          endTime={currentElement.globalTime + currentElement.duration}
        />
      )}
      <GrabberIcon
        grabberClass="Grabber-Start"
        iconClass={iconClass}
        isVideo={isVideo}
      />
      {isVideo ? (<Overlay />) : (
        <BarContent
          currentElement={currentElement}
          iconClass={iconClass}
          iconType={iconType}
          isSmallElement={isSmallElement}
        />
      )}
      <GrabberIcon
        grabberClass="Grabber-End"
        iconClass={iconClass}
        isVideo={isVideo}
      />
    </Fragment>
  );
};

export default Bar;
